import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useClient } from "../../common/ClientProvider";
import { CallsService } from "./CallsService";

interface CallsServiceProviderProps {
  children: React.ReactNode;
}

export const CallsServiceContext = React.createContext<CallsService | undefined>(undefined);

export const CallsServiceProvider: React.FC<CallsServiceProviderProps> = ({ children }) => {
  const { getAccessTokenSilently } = useAuth0();
  const { currentClientId } = useClient();

  const service = React.useMemo(() => {
    return new CallsService(getAccessTokenSilently, currentClientId);
  }, [getAccessTokenSilently, currentClientId]);

  return <CallsServiceContext.Provider value={service}>{children}</CallsServiceContext.Provider>;
};

export const useCallsService = (): CallsService => {
  const context = React.useContext(CallsServiceContext);
  if (context === undefined) {
    throw new Error("useCallsService must be used within a CallsServiceProvider");
  }
  return context;
};
